module.exports = __webpack_public_path__ + "img/v2_1.b591d6a5.png";